var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-toolbar',{staticClass:"toolbarCorners",attrs:{"dense":"","color":"primary","dark":"","flat":""}},[_c('v-toolbar-title',[_vm._v(_vm._s(_vm.name.toUpperCase()))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }